import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#6a1b9a',
    },
    secondary: {
      main: '#ff4081',
    },
  },
  typography: {
    fontFamily: '"Pyidaungsu", sans-serif',
    h1: {
      fontFamily: '"Pyidaungsu", sans-serif',
      fontWeight: 550,
      fontSize: '3rem',
    },
    h2: {
      fontFamily: '"Pyidaungsu", sans-serif',
      fontWeight: 550,
      fontSize: '2.5rem',
    },
    h3: {
        fontFamily: '"Pyidaungsu", sans-serif',
        fontWeight: 550,
        fontSize: '2rem',
      },
    h4: {
        fontFamily: '"Pyidaungsu", sans-serif',
        fontWeight: 550,
        fontSize: '1.5rem',
      },
    h5: {
        fontFamily: '"Pyidaungsu", sans-serif',
        fontWeight: 550,
        fontSize: '1rem',
      },
    h6: {
        fontFamily: '"Pyidaungsu", sans-serif',
        fontWeight: 550,
        fontSize: '1rem',
      },
    body1: {
      fontFamily: '"Pyidaungsu", sans-serif',
      fontWeight: 400,
      fontSize: '1rem',
    },
    button:{
      fontFamily: '"Pyidaungsu", sans-serif',
      fontWeight: 400,
      fontSize: '1rem',
    },
    table:{
      fontFamily: '"Pyidaungsu", sans-serif',
      fontWeight: 400,
      fontSize: '1rem',
    },
    th:{
      fontFamily: '"Pyidaungsu", sans-serif',
      fontWeight: 400,
      fontSize: '1rem',
    },
    td:{
      fontFamily: '"Pyidaungsu", sans-serif',
      fontWeight: 400,
      fontSize: '1rem',
    }
    // Define other text variants as needed
  },
  components: {
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontSize: '14px', // Customize the font size for table cells
        },
        head: {
          fontSize: '16px', // Customize the font size for table header cells
          fontWeight: 'bold', // Optionally make header font bold
        },
        body: {
          fontSize: '16px', // Customize the font size for table body cells
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          fontSize: '14px', // Customize the font size for list items
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          fontSize: '16px', // Customize the primary text font size for list items
        },
        secondary: {
          fontSize: '14px', // Customize the secondary text font size for list items
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontSize: '16px',
          color:'#000000' // Customize the font size for tabs
        },
      },
    },
    MuiTabScrollButton: {
      styleOverrides: {
        root: {
          fontSize: '16px', // Customize the font size for tab scroll buttons
        },
      },
    },
  },
});

export default theme;
